<script>
	import { _ } from 'svelte-i18n';
	import { onDestroy, onMount } from 'svelte';
	import { push, pop, replace } from 'svelte-spa-router'
	import UIkit from 'uikit';
	import axios from 'axios';
	import { dictionary, addMessages } from 'svelte-i18n';
	import Icons from 'uikit/dist/js/uikit-icons';
	import { request, getUsers, getRoles, getPermissions }  from './functions/http-helpers';
	import { url } from './stores/url.js';
	import { swalConfirm } from './functions/html-helpers.js'
	import { user } from './stores/user.js';
	import { languages } from './stores/languages.js'; 
	import { locale } from 'svelte-i18n';
	import { language } from './stores/language.js';
	import { view_width } from './stores/view_width.js';
	import { location } from 'svelte-spa-router'
	import '../node_modules/toastr/build/toastr.min.css';
	import '../node_modules/uikit/dist/css/uikit.min.css';
	import './styles/darkmode.css';
	import './styles/main.css';
	import './functions/language.js';
	UIkit.use(Icons);



	/* SETUP */
	let view_height = 0;
	onMount(() => {
		locale.set('de');
		if(!$user.id) {
			push('/auth/login');
		}		
		$view_width = window.innerWidth;
		view_height = window.innerHeight;
	});
	
	window.addEventListener('resize', function(event) {
		$view_width = window.innerWidth;
		view_height = window.innerHeight;
	}, true); 
	
	axios.default.withCredentials = true;
	axios.defaults.validateStatus = false;
	axios.interceptors.request.use(function(config) {
		config.headers.Authorization = `Bearer ${$user.jwt}`;
		return config;
	});

	const unsub_language = language.subscribe((lan) => {
		locale.set(lan);
	});
	onDestroy(() => {
		unsub_language();
	});



	/* GPS tracking */ 
	



	/* WATCH / COMPUTED */
	$: contentHeight = getContentHeight($view_width, view_height, $user);
	function getContentHeight() { 
		let content_height = document.documentElement.clientHeight - (($user?.id) ? 73 : 0); //Footer
		return `
			height: ${content_height}px !important;
			max-height: ${content_height}px;
			position: relative;`; 
	}



	/* GET */
	async function getTranslations() {
		const response = await axios.request({
			method: 'GET',
			url: `${$url}/textlist.csv`,
			responseType: 'arraybuffer',
			reponseEncoding: 'binary'
		});
		const decoder = new TextDecoder('ISO-8859-1');
		let decoded = decoder.decode(response.data) 
		let translation_array = decoded.split('\n').map(row => row.split(';')); // reihen trennen durch .split('\n'), spalten innerhalb der reihen trennen durch .split('\t')
		translation_array.shift();

		for(let l = 0; l < $languages.length; l++) {
			let translations = {}; // key values für plc variablen damit so aufrufbar: plc_variablen.automatik.value == 1
			for(let i = 0; i < translation_array.length; i++) {
				if(translation_array[i][0] == 'active_alarms') {
					console.log(translation_array[i])
				}
				if(translation_array[i][0] && translation_array[i][$languages[l].col]) {
					translations[translation_array[i][0]] = translation_array[i][$languages[l].col];
				}
			}
			addMessages($languages[l].short, translations);
		}
	}
	getTranslations();



	// Router
	import Router from 'svelte-spa-router'
	import Navbar from './components/Navbar.svelte';
	import Home from './pages/Home.svelte'
	import Auth from './components/Auth.svelte'
	import NotFound from './components/NotFound.svelte'
	import Permissions from './pages/Permissions.svelte';
	import Users from './pages/Users.svelte';
	import Roles from './pages/Roles.svelte';
	import Profile from './pages/Profile.svelte';
	import Settings from './pages/Settings.svelte';
	import EmailLink from './pages/EmailLink.svelte';
	import Overview from './pages/Overview.svelte';
    import MobileFooterNav from './components/MobileFooterNav.svelte';


	const routes = { 
		'/': Home, 

		'/profil': Profile,
		'/email': EmailLink,
		'/overview': Overview, 
		'/einstellungen': Settings,
		'/auth/:auth_type': Auth,
		'/berechtigungen': Permissions,
		'/benutzer': Users,
		'/benutzerrollen': Roles,
		'*': NotFound,
	};


	async function verifyEmail() {
		const [ data, error ] = await request('post', `${$url}/auth/send_verification_email`, {
			email: $user.email
		});
		if(!error) { 
			swalConfirm($_('email_send'), $_('swal_confirm_email'), 'success', 'OK');
		}
	}
</script>
 
<main>
	<!--
	<span class="uk-position-top-left">{$view_width}</span>
	-->

	<!--
	{#if $user.id && $user.verified_at}
		<Navbar /> 
	{/if}

	{#if ($user.id && !$user.verified_at) && $location != '/email/'}
		<div class="uk-container">
			<div class="card uk-margin-top">
				<h3 class="uk-text-center">{$_('email_not_verified')}</h3>
				<button class="uk-button uk-button-primary uk-align-center" on:click={() => verifyEmail()}>{$_('verify_email')}</button>
			</div> 
		</div>
	{:else}
		<Router {routes} />
	{/if} 
	-->

	<div style="{contentHeight}">
		<!-- $view_width < 960 --> 
		<div style="{true ? 'max-height:100%; overflow:auto;' : ''}">
			<Router {routes} />
		</div> 
	</div> 
	<!-- {#if $view_width < 960} -->
		<MobileFooterNav class="uk-position-bottom" />
	<!-- {/if} -->
	

</main>

<style>
	
</style>